<template>
    <div class="form-contact">

        <h1 class="header-form" :style="{'background': primary_color, 'border-radius':'15px 15px 0 0'}">
            Atendimento Digital - Empresa
            <i class="fas fa-times" style="cursor: pointer" @click="$parent.handleChatWindow"></i>
        </h1>

        <div class="form-contact-content">
          <form @submit.prevent="BeginChat" id="form-contato" ref="formContato">
               <div v-for="field in fields" :key="field.wid_id" class="input-content">

                   <label class="label-cosmos">{{field.label}}</label>

                   <input class="form-control-cosmos" :type="field.type" v-if="field.type != 'select'" :required="field.required" :placeholder="field.placeholder" :id="field.wid_id" :name="field.name">

                   <select class="form-control-cosmos" v-else :name="field.name" :id="field.id" :required="field.required">
                        <option :value="option.value" :key="option.value" v-for="option in field.options">{{option.label}}</option>
                   </select>

               </div>
               <button class="button-new"
               :style="styleObject" type="submit">{{btnBeginLabel}}</button>
          </form>
        </div>
    </div>

</template>


<script>
export default {
    name:"FormContato",
    data(){
        return {
            socketEndpoint: process.env.VUE_APP_SOCKET_ENDPOINT,
            fields: this.$parent.fields,
            btnBeginLabel: this.$parent.btnBeginLabel,
            company: this.$parent.company,
            primary_color: this.$parent.primary_color,
            secondary_color: this.$parent.secondary_color,
            cor_botao_chat: this.$parent.cor_botao_chat
        }
    },
    computed:{

        styleObject: function() {
            return {
                '--color': this.secondary_color,
            }
        }
    },
    methods:{

        BeginChat(){
             let inputs = document.querySelectorAll("#form-contato input[type=text]");
             let selects = document.querySelectorAll("#form-contato select");
             let form = {};
             for(let i=0;i<inputs.length;i++){
                 form[inputs[i].name] = inputs[i].value
             }
             //selects
             for(let i=0;i<selects.length;i++){
                 form[selects[i].name] = selects[i].value
             }
            this.$emit('preencheForm', form);
             this.$router.push({
                 path: 'chat',
             })
        },

    },
    mounted(){
        this.$emit('encerraSessao');
    }
}
</script>
